import React from "react";
import Tabs from "@material-ui/core/Tabs";
import { Tab } from "..";
import { AppBar } from "@material-ui/core";

var TabsComponent = function TabsComponent(props) {
  var main;
  var content;
  var tabs;
  tabs = props.contentTabs.map(function (_tab) {
    return /*#__PURE__*/React.createElement(Tab, {
      "data-cy": _tab.value,
      icon: _tab.icon,
      disabled: _tab.disabled,
      label: _tab.label,
      value: _tab.value,
      key: _tab.value,
      wrapped: _tab.wrapped
    });
  });
  content = props.orientation === "vertical" ? /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      padding: "30px"
    }
  }, /*#__PURE__*/React.createElement(Tabs, {
    "data-cy": props.value,
    value: props.value,
    onChange: props.onChange,
    variant: props.variant,
    textColor: props.textColor,
    indicatorColor: props.indicatorColor,
    className: props.className,
    orientation: props.orientation,
    style: props.style
  }, tabs)) : /*#__PURE__*/React.createElement(Tabs, {
    "data-cy": props.value,
    value: props.value,
    onChange: props.onChange,
    variant: props.variant,
    textColor: props.textColor,
    indicatorColor: props.indicatorColor,
    className: props.className,
    style: props.style
  }, tabs);
  main = props.isAppBar ? /*#__PURE__*/React.createElement(AppBar, {
    position: props.appBarPosition,
    color: props.appBarColor
  }, content) : content;
  return main;
};

export default TabsComponent;